export default __webpack_public_path__ + "static/media/YB_Logo.d62432d8.png";